import {
  Button,
  Col,
  Form,
  Image,
  message,
  Popconfirm,
  Row,
  Select,
  Skeleton,
  Space,
} from "antd";
import TextArea from "antd/lib/input/TextArea";
import React, { useState, useEffect, useRef } from "react";
import UploadImage from "../../../midjourney/components/UploadImage";
import axios from "axios";
import {
  API_KEY_OPENAI,
  ASSET_URL_VIEW_IMAGE,
  AWS_API_UPLOAD_IMAGE,
} from "../../../../../config";
import { DeleteOutlined } from "@ant-design/icons";
import UserMessage from "../MessageItem/UserMessage";
import shortUUID from "short-uuid";
export default function GeneratorImage() {
  const list = useRef();
  const [form] = Form.useForm();
  const [url, setUrl] = useState("");
  const [uuidUpload, setUuidUpload] = useState("1");
  const [loading, setLoading] = useState(false);
  const [loadingUpload, setLoadingUpload] = useState(false);
  const imageGenerationModel = localStorage.getItem("imageGeneration-model");
  const imageGenerationSize = localStorage.getItem("imageGeneration-size");
  const [size, setSize] = useState(imageGenerationSize || "auto");
  const [model, setModel] = useState(imageGenerationModel || "gpt-image-1.5");
  const [models, setModels] = useState([]);
  const [isUpload, setIsUpload] = useState(false);
  const sizes = [
    {
      value: "auto",
      labe: "auto",
    },
    {
      value: "1024x1024",
      labe: "1024x1024 (square)",
    },
    {
      value: "1536x1024",
      labe: "1536x1024 (landscape)",
    },
    {
      value: "1024x1536",
      labe: "1024x1536 (portrait)",
    },
  ];

  const sizesDall = [
    {
      value: "1024x1024",
      labe: "1024x1024 (square)",
    },
    {
      value: "1792x1024",
      labe: "1792x1024 (landscape)",
    },
    {
      value: "1024x1792",
      labe: "1024x1792 (portrait)",
    },
  ];
  const conversationGeneratorImage = localStorage.getItem(
    "conversation-generator-image",
  );
  const [conversation, setconversation] = useState(
    conversationGeneratorImage ? JSON.parse(conversationGeneratorImage) : [],
  );

  useEffect(() => {
    localStorage.setItem("imageGeneration-model", model);
    localStorage.setItem("imageGeneration-size", size);
  }, [model, size]);

  const toBottom = () => {
    const container = list.current;
    if (container) {
      container.scrollTop = container.scrollHeight;
    }
  };

  function filterAndMapImageModels(modelList) {
    return modelList
      .filter((model) => {
        const name = model.value.toLowerCase();
        const excludedKeywords = [
          "embedding",
          "whisper",
          "moderation",
          "search-api",
          "davinci",
          "babbage",
          "gpt-3.5",
          "sora",
        ];

        if (excludedKeywords.some((keyword) => name.includes(keyword))) {
          return false;
        }

        const isImageSpecific =
          name.includes("dall-e") || name.includes("image");
        const isAdvancedMultimodal =
          name.includes("gpt-4o") ||
          name.includes("gpt-4.1") ||
          name.includes("gpt-5");

        return isImageSpecific || isAdvancedMultimodal;
      })
      .map((model) => {
        const name = model.value.toLowerCase();
        const isAdvancedMultimodal =
          name.includes("gpt-4o") ||
          name.includes("gpt-4.1") ||
          name.includes("gpt-5");

        const isImageInputSupported =
          isAdvancedMultimodal || name.includes("dall-e-2");

        if (isAdvancedMultimodal) {
          return {
            ...model,
            input_image: isImageInputSupported,
            tools: [{ type: "image_generation" }],
          };
        }

        return {
          ...model,
          input_image: isImageInputSupported,
        };
      });
  }

  useEffect(() => {
    const findModel = (models || []).find((e) => e.value === model);
    if (findModel) {
      const { input_image } = findModel;
      setIsUpload(input_image || false);
    }

    const isArraySize = model.indexOf("dall") >= 0 ? sizesDall : sizes;
    const findSize = isArraySize.find((e) => e.value === size);
    if (!findSize) {
      setSize("1024x1024");
      form.setFieldsValue({ size: "1024x1024" });
    }
  }, [models, model]);

  useEffect(() => {
    axios
      .get("https://api.openai.com/v1/models", {
        headers: {
          Authorization: `Bearer ${API_KEY_OPENAI}`,
        },
      })
      .then((res) => {
        return res.data.data;
      })
      .then((res) => {
        let data = res
          .map((e) => {
            return {
              value: e.id,
              label: e.id.replace(/-/g, " "),
            };
          })
          .filter((e) => {
            const noneArray = [
              "codex",
              "gpt-realtime-mini-2025-12-15",
              "audio",
              "realtime",
              "search-preview",
              "transcribe",
              "tts",
            ];
            var isShow = true;
            noneArray.forEach((s) => {
              if (e.value.indexOf(s) >= 0) {
                isShow = false;
              }
            });
            return isShow;
          });
        data = filterAndMapImageModels(data);
        setModels(data);
      });
  }, []);
  useEffect(() => {
    localStorage.setItem(
      "conversation-generator-image",
      JSON.stringify(conversation),
    );
  }, [conversation]);

  const getSignedUrl = async (mime) => {
    var headers = new Headers();
    headers.append("Content-Type", "application/json");
    var requestOptions = {
      method: "GET",
      headers: headers,
      redirect: "follow",
    };
    var signedUrl = null;
    await fetch(
      `${AWS_API_UPLOAD_IMAGE}/signedUrl?type=${mime}`,
      requestOptions,
    )
      .then((response) => response.json())
      .then((res) => (signedUrl = res))
      .catch((err) => console.error(err));
    return signedUrl;
  };

  const upload = async (base64) => {
    var file = await fetch(base64)
      .then((res) => res.arrayBuffer())
      .then((buf) => new File([buf], "tmp.png", { type: "image/png" }));
    var signedUrl = await getSignedUrl(file.type);
    const upFile = await axios
      .put(signedUrl.url, file, {
        headers: {
          "Content-Type": file.type,
        },
      })
      .catch((err) => console.error(err));

    if (upFile.status === 200) {
      return {
        status: true,
        key: signedUrl.key,
      };
    } else {
      return {
        status: false,
      };
    }
  };

  const onFinishChatProduct = async (v, imageUrl = null, isUpload = false) => {
    if (!v.prompt) return;
    setLoading(true);
    toBottom();

    setconversation((prev) => [
      {
        role: "user",
        content: v.prompt,
        ...(imageUrl ? { attached_image: imageUrl } : {}),
      },
      ...prev,
    ]);

    try {
      const isAdvancedMultimodal =
        model.includes("gpt-4") || model.includes("gpt-5");

      let endpoint = "";
      let dataRequest = {};
      let b64_json_result = "";

      if (isAdvancedMultimodal) {
        endpoint = "https://api.openai.com/v1/responses";

        let inputData = v.prompt;
        if (isUpload && imageUrl) {
          inputData = [
            {
              role: "user",
              content: [
                { type: "input_text", text: v.prompt },
                {
                  type: "input_image",
                  image_url: imageUrl,
                },
              ],
            },
          ];
        }

        dataRequest = {
          model: model,
          input: inputData,
          tools: [{ type: "image_generation", size: size }],
        };

        setUuidUpload(shortUUID.generate());
        form.setFieldsValue({ prompt: "" });
        const response = await axios.post(endpoint, dataRequest, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${API_KEY_OPENAI}`,
          },
        });
        const findb64_json_result = (response.data.output || []).find(
          (e) => e.type === "image_generation_call",
        );
        b64_json_result = findb64_json_result
          ? findb64_json_result.result
          : null;
      } else {
        if (isUpload && imageUrl) {
          console.warn(
            "Dòng DALL-E tạo ảnh mới qua JSON không hỗ trợ truyền trực tiếp ảnh vào prompt. Bỏ qua ảnh đính kèm.",
          );
        }

        endpoint = "https://api.openai.com/v1/images/generations";
        dataRequest = {
          model: model,
          prompt: v.prompt,
          n: 1,
          size: size,
        };

        setUuidUpload(shortUUID.generate());
        form.setFieldsValue({ prompt: "" });
        const response = await axios.post(endpoint, dataRequest, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${API_KEY_OPENAI}`,
          },
        });
        if (model.indexOf("dall") >= 0) {
          const findURLResult = response.data.data.find((e) => e.url);
          b64_json_result = findURLResult ? findURLResult.url : null;
        } else {
          const findB64Result = response.data.data.find((e) => e.b64_json);
          b64_json_result = findB64Result ? findB64Result.b64_json : null;
        }
      }

      if (!b64_json_result) {
        throw new Error("No image data was returned from the API.");
      }
      let url;
      if (model.indexOf("dall") >= 0) {
        url = b64_json_result;
      } else {
        const image_base64 = "data:image/png;base64," + b64_json_result;

        const uploadFile = await upload(image_base64);

        if (!uploadFile) {
          message.error(`Upfile error`);
          setLoading(false);
          toBottom();
          return;
        }

        url = ASSET_URL_VIEW_IMAGE + uploadFile.key;
      }
      setconversation((prev) => [
        {
          role: "assistant",
          content: url,
        },
        ...prev,
      ]);
    } catch (error) {
      const errorMsg =
        error.response?.data?.error?.message ||
        error.message ||
        "Unknown error";
      message.error(`Error: ${errorMsg}`);
      console.error("API Call Error: ", error.response?.data || error);
    } finally {
      setLoading(false);
      toBottom();
    }
  };

  const onReplyImageEdit = (url) => {
    setUrl(url);
  };

  const onFinishFailed = () => {};
  const handleDeleteConversations = () => {
    setconversation([]);
  };

  const onReplyEdit = (v) => {
    form.setFieldsValue({
      prompt: v,
    });
  };
  return (
    <Row>
      <Col
        span={12}
        style={{
          position: "relative",
        }}
      >
        <Form
          disabled={loading}
          form={form}
          layout="vertical"
          onFinish={(v) => onFinishChatProduct(v, url, isUpload)}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item name="model" label="Model">
            <Select
              defaultValue={model}
              value={model}
              style={{
                width: 200,
              }}
              options={models}
              onChange={(v) => {
                setModel(v);
              }}
            />
          </Form.Item>
          <Form.Item name="size" label="Size">
            <Select
              defaultValue={size}
              value={size}
              style={{
                width: 200,
              }}
              options={model.indexOf("dall") >= 0 ? sizesDall : sizes}
              onChange={(v) => {
                setSize(v);
              }}
            />
          </Form.Item>
          {isUpload && (
            <Form.Item label="Image">
              <UploadImage
                onLoading={setLoadingUpload}
                uuid={uuidUpload}
                sendUrl={url}
                onChange={(v) => setUrl(v)}
              />
            </Form.Item>
          )}

          <Form.Item
            name="prompt"
            label="Prompt"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <TextArea rows={5} />
          </Form.Item>
          <Form.Item>
            <Button
              loading={loading || loadingUpload}
              type="primary"
              htmlType="submit"
            >
              Generation
            </Button>
          </Form.Item>
        </Form>
      </Col>
      <Col
        span={12}
        style={{
          position: "relative",
        }}
      >
        {conversation.length > 0 && (
          <div className="group-preview-chatgpt">
            <div className="group-preview-chatgpt__control">
              <Space>
                <Popconfirm
                  title="Are you sure delete?"
                  onConfirm={handleDeleteConversations}
                  onCancel={() => {}}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button
                    type="dashed"
                    className="btn-delete"
                    icon={<DeleteOutlined />}
                  >
                    Delete all conversations
                  </Button>
                </Popconfirm>
              </Space>
            </div>
            <ul className="message-group" ref={list}>
              {loading && (
                <li className="message-item-assistant">
                  <div
                    className="message-item-content"
                    style={{
                      overflow: "hidden",
                      padding: 0,
                    }}
                  >
                    <Skeleton.Image
                      style={{
                        width: 400,
                        height: 400,
                      }}
                      active={true}
                    />
                  </div>
                </li>
              )}
              {conversation.map((messageItem, index) => (
                <li className={`message-item-${messageItem.role}`} key={index}>
                  {messageItem.role === "user" && (
                    <UserMessage onReplyEdit={onReplyEdit}>
                      {messageItem.content}
                    </UserMessage>
                  )}
                  {messageItem.role === "assistant" && (
                    <div className="message-item-control-group">
                      <div
                        style={{
                          overflow: "hidden",
                          padding: 0,
                          width: 400,
                          maxWidth: "100%",
                        }}
                        className="message-item-content"
                      >
                        <Image
                          style={{
                            width: "100%",
                          }}
                          width={"100%"}
                          src={messageItem.content}
                        />
                        {isUpload && (
                          <div className="message-item-control">
                            <button
                              title="Edit image"
                              onClick={() =>
                                onReplyImageEdit(messageItem.content)
                              }
                              className="btn-control-chat"
                            >
                              <i className="fa-solid fa-reply"></i>
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </div>
        )}
      </Col>
    </Row>
  );
}
